var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftBlackIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.199376 8.99953C0.199376 8.29953 0.469374 7.59953 0.999375 7.06953L7.51938 0.549531C7.80938 0.259531 8.28938 0.259531 8.57937 0.549531C8.86937 0.839531 8.86937 1.31953 8.57937 1.60953L2.05937 8.12953C1.57937 8.60953 1.57937 9.38953 2.05937 9.86953L8.57937 16.3895C8.86937 16.6795 8.86937 17.1595 8.57937 17.4495C8.28937 17.7395 7.80937 17.7395 7.51937 17.4495L0.999374 10.9295C0.469374 10.3995 0.199376 9.69953 0.199376 8.99953Z",
    fill: "#101924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlackIcon);
export default __webpack_public_path__ + "static/media/arrow-left-black-icon.e8ef80821d1aa0137a675af688b6fc4b.svg";
export { ForwardRef as ReactComponent };